import React from 'react'
import IconButton from '../../common/icon_button/icon_button'

export const TaskAction = ({ taskCompleted, onToggleCompleted, showVisibleOption, onToggleVisibility, onEdit }) => {
  return (
    <>
      <div className='task-done-button'>
        {!taskCompleted ? (
          <IconButton
            icon='done'
            type='disabled'
            canHover
            onClick={ev =>
              onToggleCompleted && onToggleCompleted(true, ev)}
          />
        ) : (
          <IconButton
            icon='done'
            type='success'
            canHover
            onClick={ev =>
              onToggleCompleted && onToggleCompleted(false, ev)}
          />
        )}
      </div>
      <div className='task-edit-button'>{showVisibleOption ? (
        <IconButton
          size='normal'
          icon='eye'
          type='secondary'
          canHover
          onClick={onToggleVisibility}
        />
      ) : (
        <IconButton
          size='normal'
          icon='edit'
          type='secondary'
          canHover
          onClick={onEdit}
        />
      )}
      </div>
    </>
  )
}
